import { delayolwo40i9ucjz as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { RViewWithSecondaryAction1hi9cbpgjqv82 as RViewWithSecondaryAction } from '../RView.mjs';
import { ClickableSemantic_getInstance2dwzbc0ganf8f as ClickableSemantic_getInstance } from '../../models/Theme.mjs';
import { Paire9pteg33gng7 as Pair } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { Companion_instance15pczmasjuxgh as Companion_instance } from './ContainingView.commonHtml.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay(500n, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = $this.gbd_1.fbd_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.gbd_1.wbe_1 = null;
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp_0 = $this.gbd_1.tb5_1.zb3_1.ib7_1.disabled;
    if (!(((!(tmp_0 == null) ? typeof tmp_0 === 'boolean' : false) ? tmp_0 : null) === true)) {
      tmp0_safe_receiver.xbe($this$launch);
    }
  }
  return Unit_instance;
}
var Button$lambda$slambdaClass;
function Button$lambda$slambda() {
  if (Button$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.gbd_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    Button$lambda$slambdaClass = $;
  }
  return Button$lambda$slambdaClass;
}
function Button$lambda$slambda_0(this$0) {
  var i = new (Button$lambda$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var ButtonClass;
function Button() {
  if (ButtonClass === VOID) {
    class $ extends RViewWithSecondaryAction() {
      constructor(context) {
        super(context);
        this.jba(this.ob6_1.ybe(ClickableSemantic_getInstance()));
        this.tb5_1.xb3_1 = 'button';
        this.tb5_1.hb4_1.v('kiteui-stack');
        this.tb5_1.hb4_1.v('clickable');
        this.vbe_1 = new (Pair())(0.0, 0.0);
        this.wbe_1 = null;
        var beginLongPressCountdown = (e) => {
          var me = e instanceof MouseEvent ? e : null;
          var tmp = this;
          var tmp1_elvis_lhs = me == null ? null : me.pageX;
          var tmp_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
          var tmp3_elvis_lhs = me == null ? null : me.pageY;
          tmp.vbe_1 = new (Pair())(tmp_0, tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs);
          var tmp_1 = this;
          var tmp4_elvis_lhs = this.wbe_1;
          var tmp_2;
          if (tmp4_elvis_lhs == null) {
            tmp_2 = launch(this, VOID, VOID, Button$lambda$slambda_0(this));
          } else {
            tmp_2 = tmp4_elvis_lhs;
          }
          tmp_1.wbe_1 = tmp_2;
          return Unit_instance;
        };
        var cancelOrClick = (e) => {
          var me = e instanceof MouseEvent ? e : null;
          var tmp0_safe_receiver = this.wbe_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.ma3();
          }
          var tmp;
          if (!(this.wbe_1 == null)) {
            this.wbe_1 = null;
            var tmp_0;
            if (!(me == null)) {
              var dx = me.pageX - this.vbe_1.af_1;
              var dy = me.pageY - this.vbe_1.bf_1;
              // Inline function 'kotlin.math.sqrt' call
              var x = dx * dx + dy * dy;
              var dist = Math.sqrt(x);
              var tmp_1;
              if (dist <= 5) {
                var tmp1_safe_receiver = this.kbg_1;
                if (tmp1_safe_receiver == null)
                  null;
                else {
                  tmp1_safe_receiver.xbe(this);
                }
                tmp_1 = Unit_instance;
              }
              tmp_0 = tmp_1;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        };
        var cancel = (event) => {
          var tmp0_safe_receiver = this.wbe_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.ma3();
          }
          this.wbe_1 = null;
          return Unit_instance;
        };
        var tmp0 = this.tb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name = 'mousedown';
        var listener = beginLongPressCountdown;
        var tmp0_safe_receiver = tmp0.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          tmp0_safe_receiver.addEventListener(name, (it) => {
            listener(it);
            return Unit_instance;
          });
          tmp = Unit_instance;
        }
        if (tmp == null) {
          // Inline function 'kotlin.run' call
          var tmp_0 = tmp0.eb4_1['on' + name];
          var old = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
          var tmp_1 = 'on' + name;
          tmp0.eb4_1[tmp_1] = (it) => {
            var tmp0_safe_receiver = old;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener(it);
            return Unit_instance;
          };
        }
        var tmp0_0 = this.tb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_0 = 'touchstart';
        var listener_0 = beginLongPressCountdown;
        var tmp0_safe_receiver_0 = tmp0_0.vb3_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          tmp0_safe_receiver_0.addEventListener(name_0, (it) => {
            listener_0(it);
            return Unit_instance;
          });
          tmp_2 = Unit_instance;
        }
        if (tmp_2 == null) {
          // Inline function 'kotlin.run' call
          var tmp_3 = tmp0_0.eb4_1['on' + name_0];
          var old_0 = (!(tmp_3 == null) ? typeof tmp_3 === 'function' : false) ? tmp_3 : null;
          var tmp_4 = 'on' + name_0;
          tmp0_0.eb4_1[tmp_4] = (it) => {
            var tmp0_safe_receiver = old_0;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_0(it);
            return Unit_instance;
          };
        }
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var this_0 = this.tb5_1;
        var listener_1 = cancelOrClick;
        var tmp0_safe_receiver_1 = this_0.vb3_1;
        var tmp_5;
        if (tmp0_safe_receiver_1 == null) {
          tmp_5 = null;
        } else {
          tmp0_safe_receiver_1.addEventListener('mouseup', (it) => {
            listener_1(it);
            return Unit_instance;
          });
          tmp_5 = Unit_instance;
        }
        if (tmp_5 == null) {
          // Inline function 'kotlin.run' call
          var tmp_6 = this_0.eb4_1['on' + 'mouseup'];
          var old_1 = (!(tmp_6 == null) ? typeof tmp_6 === 'function' : false) ? tmp_6 : null;
          var tmp_7 = 'on' + 'mouseup';
          this_0.eb4_1[tmp_7] = (it) => {
            var tmp0_safe_receiver = old_1;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_1(it);
            return Unit_instance;
          };
        }
        var tmp0_1 = this.tb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_1 = 'mouseleave';
        var listener_2 = cancel;
        var tmp0_safe_receiver_2 = tmp0_1.vb3_1;
        var tmp_8;
        if (tmp0_safe_receiver_2 == null) {
          tmp_8 = null;
        } else {
          tmp0_safe_receiver_2.addEventListener(name_1, (it) => {
            listener_2(it);
            return Unit_instance;
          });
          tmp_8 = Unit_instance;
        }
        if (tmp_8 == null) {
          // Inline function 'kotlin.run' call
          var tmp_9 = tmp0_1.eb4_1['on' + name_1];
          var old_2 = (!(tmp_9 == null) ? typeof tmp_9 === 'function' : false) ? tmp_9 : null;
          var tmp_10 = 'on' + name_1;
          tmp0_1.eb4_1[tmp_10] = (it) => {
            var tmp0_safe_receiver = old_2;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_2(it);
            return Unit_instance;
          };
        }
        var tmp0_2 = this.tb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_2 = 'touchend';
        var listener_3 = cancelOrClick;
        var tmp0_safe_receiver_3 = tmp0_2.vb3_1;
        var tmp_11;
        if (tmp0_safe_receiver_3 == null) {
          tmp_11 = null;
        } else {
          tmp0_safe_receiver_3.addEventListener(name_2, (it) => {
            listener_3(it);
            return Unit_instance;
          });
          tmp_11 = Unit_instance;
        }
        if (tmp_11 == null) {
          // Inline function 'kotlin.run' call
          var tmp_12 = tmp0_2.eb4_1['on' + name_2];
          var old_3 = (!(tmp_12 == null) ? typeof tmp_12 === 'function' : false) ? tmp_12 : null;
          var tmp_13 = 'on' + name_2;
          tmp0_2.eb4_1[tmp_13] = (it) => {
            var tmp0_safe_receiver = old_3;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_3(it);
            return Unit_instance;
          };
        }
        var tmp0_3 = this.tb5_1;
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.addEventListener' call
        var name_3 = 'touchcancel';
        var listener_4 = cancel;
        var tmp0_safe_receiver_4 = tmp0_3.vb3_1;
        var tmp_14;
        if (tmp0_safe_receiver_4 == null) {
          tmp_14 = null;
        } else {
          tmp0_safe_receiver_4.addEventListener(name_3, (it) => {
            listener_4(it);
            return Unit_instance;
          });
          tmp_14 = Unit_instance;
        }
        if (tmp_14 == null) {
          // Inline function 'kotlin.run' call
          var tmp_15 = tmp0_3.eb4_1['on' + name_3];
          var old_4 = (!(tmp_15 == null) ? typeof tmp_15 === 'function' : false) ? tmp_15 : null;
          var tmp_16 = 'on' + name_3;
          tmp0_3.eb4_1[tmp_16] = (it) => {
            var tmp0_safe_receiver = old_4;
            if (tmp0_safe_receiver == null)
              null;
            else
              tmp0_safe_receiver(it);
            listener_4(it);
            return Unit_instance;
          };
        }
      }
      ub9(index, view) {
        super.ub9(index, view);
        Companion_instance.lbg(this, index, view);
      }
    }
    initMetadataForClass($, 'Button');
    ButtonClass = $;
  }
  return ButtonClass;
}
//region block: exports
export {
  Button as Button263cw152yl80e,
};
//endregion

//# sourceMappingURL=Button.commonHtml.mjs.map
